export const REFERRAL_CODE_KEY = "ccmgd.ref";
